import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuardService, AuthGuardMenuService} from 'compob2b-auth';
import {LayoutComponent} from '../admin-shared/layout/layout.component';



const routes: Routes = [{
  path: '',
  component: LayoutComponent,
  children: [
    {path: 'cabinet', redirectTo: '/cabinet/dashboard', pathMatch: 'full'},
    {path: 'cabinet/security', redirectTo: '/cabinet/security/administrators', pathMatch: 'full'},
    {path: 'cabinet/cms', redirectTo: '/cabinet/cms/news', pathMatch: 'full'},
    {path: 'cabinet/crm', redirectTo: '/cabinet/crm/customers', pathMatch: 'full'},
    {path: 'cabinet/ecommerce', redirectTo: '/cabinet/ecommerce/delivery/method', pathMatch: 'full'},
    {path: 'cabinet/pim', redirectTo: '/cabinet/pim/catalog', pathMatch: 'full'},
    {path: 'cabinet/marketplace', redirectTo: '/cabinet/marketplace/marketplace-channels', pathMatch: 'full'},
    {
      path: 'cabinet/dashboard',
      loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
      canActivate: [AuthGuardService, AuthGuardMenuService]
    },
    {
      path: 'cabinet/batch',
      loadChildren: () => import('./batch/batch.module').then(m => m.BatchModule),
      canActivate: [AuthGuardService, AuthGuardMenuService]
    },
    {
      path: 'cabinet/dam',
      loadChildren: () => import('./dam/dam.module').then(m => m.DamModule),
      canActivate: [AuthGuardService, AuthGuardMenuService]
    },
    {
      path: 'cabinet/security',
      loadChildren: () => import('./security/security.module').then(m => m.SecurityModule),
      canActivate: [AuthGuardService, AuthGuardMenuService]
    },
    {
      path: 'cabinet/cms',
      loadChildren: () => import('./cms/cms.module').then(m => m.CmsModule),
      canActivate: [AuthGuardService, AuthGuardMenuService]
    },
    {
      path: 'cabinet/ecommerce',
      loadChildren: () => import('./ecommerce/ecommerce.module').then(m => m.EcommerceModule),
      canActivate: [AuthGuardService, AuthGuardMenuService]
    },
    {
      path: 'cabinet/pim',
      loadChildren: () => import('./pim/pim.module').then(m => m.PimModule),
      canActivate: [AuthGuardService, AuthGuardMenuService]
    },
    {
      path: 'cabinet/wms',
      loadChildren: () => import('./wms/wms.module').then(m => m.WmsModule),
      canActivate: [AuthGuardService, AuthGuardMenuService]
    },
    {
      path: 'cabinet/settings',
      loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule),
      canActivate: [AuthGuardService, AuthGuardMenuService]
    },
    {
      path: 'cabinet/crm',
      loadChildren: () => import('./crm/crm.module').then(m => m.CrmModule),
      canActivate: [AuthGuardService, AuthGuardMenuService]
    },
    {
      path: 'cabinet/search',
      loadChildren: () => import('./search/search.module').then(m => m.SearchModule),
      canActivate: [AuthGuardService, AuthGuardMenuService]
    },
    {
      path: 'cabinet/profile',
      loadChildren: () => import('./security/profile/profile.module').then(m => m.ProfileModule),
      canActivate: [AuthGuardService]
    },
    {
      path: 'cabinet/marketplace',
      loadChildren: () => import('./marketplace/marketplace.module').then(m => m.MarketplaceModule),
      canActivate: [AuthGuardService, AuthGuardMenuService]
    },
  ],
}];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class CabinetRoutingModule { }
